import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _hoisted_1 = {
  class: "hdr-outer",
  id: "headerScroll"
}
const _hoisted_2 = {
  class: "lmd-menu",
  id: "menuOpen"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { title: "Home" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Home", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { title: "Services" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Services", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { title: "Industries" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Industries", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { title: "Clients" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Clients", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { title: "Career" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Careers", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { title: "Teams" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Our Team", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { title: "About-us" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "About Us", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { title: "Blogs" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Blogs", -1)
const _hoisted_19 = { class: "lmd-header" }
const _hoisted_20 = { class: "container-fluid" }
const _hoisted_21 = { class: "custom-row" }
const _hoisted_22 = { class: "site-logo" }
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"lmd-hdr-right\"><div class=\"menu-icon\"><button id=\"menuclick\"><span class=\"hamb-top\"></span><span class=\"hamb-mid\"></span><span class=\"hamb-btm\"></span></button></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", null, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: _normalizeClass({ active: _ctx.$route.path === '/' }),
              to: "/",
              id: "homeMenuLink",
              onClick: _ctx.closeMenu
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createTextVNode(),
                _hoisted_4
              ]),
              _: 1
            }, 8, ["class", "onClick"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: _normalizeClass({ active: _ctx.$route.path === '/our-services' }),
              to: "/our-services",
              id: "ourServicesLink",
              onClick: _ctx.closeMenu
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(),
                _hoisted_6
              ]),
              _: 1
            }, 8, ["class", "onClick"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: _normalizeClass({ active: _ctx.$route.path === '/Industries' }),
              to: "/Industries",
              id: "ourIndustriesLink",
              onClick: _ctx.closeMenu
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createTextVNode(),
                _hoisted_8
              ]),
              _: 1
            }, 8, ["class", "onClick"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: _normalizeClass({ active: _ctx.$route.path === '/client' }),
              to: "/client",
              id: "ourClientsLink",
              onClick: _ctx.closeMenu
            }, {
              default: _withCtx(() => [
                _hoisted_9,
                _createTextVNode(),
                _hoisted_10
              ]),
              _: 1
            }, 8, ["class", "onClick"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: _normalizeClass({ active: _ctx.$route.path === '/career' }),
              to: "/career",
              id: "ourCareersLink",
              onClick: _ctx.closeMenu
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _createTextVNode(),
                _hoisted_12
              ]),
              _: 1
            }, 8, ["class", "onClick"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: _normalizeClass({ active: _ctx.$route.path === '/our-team' }),
              to: "/our-team",
              id: "ourTeamLink",
              onClick: _ctx.closeMenu
            }, {
              default: _withCtx(() => [
                _hoisted_13,
                _createTextVNode(),
                _hoisted_14
              ]),
              _: 1
            }, 8, ["class", "onClick"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: _normalizeClass({ active: _ctx.$route.path === '/about-us' }),
              to: "/about-us",
              id: "AboutUsLink",
              onClick: _ctx.closeMenu
            }, {
              default: _withCtx(() => [
                _hoisted_15,
                _createTextVNode(),
                _hoisted_16
              ]),
              _: 1
            }, 8, ["class", "onClick"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: _normalizeClass({ active: _ctx.$route.path === '/blogs' }),
              to: "/blogs",
              id: "BlogsLink",
              onClick: _ctx.closeMenu
            }, {
              default: _withCtx(() => [
                _hoisted_17,
                _createTextVNode(),
                _hoisted_18
              ]),
              _: 1
            }, 8, ["class", "onClick"])
          ])
        ])
      ])
    ]),
    _createElementVNode("header", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _imports_0,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args))),
                  alt: "Logo"
                })
              ]),
              _: 1
            })
          ]),
          _hoisted_23
        ])
      ])
    ])
  ]))
}